import { isAgentUserId } from "~/lib/matrix";

export function ownAgentUserId(userId: string | null): string | null {
  if (!userId || !userId.startsWith("@") || isAgentUserId(userId)) return null;
  const colon = userId.indexOf(":");
  if (colon < 0) return null;
  const localpart = userId.slice(1, colon);
  if (localpart.length === 0) return null;
  return `@_agent_${localpart}${userId.slice(colon)}`;
}
